var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVolumeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08324 9.48608L8.83386 6.72157L41.6355 39.3388L38.8849 42.1033L34.8655 38.1042C32.8357 39.7326 30.4332 40.9512 27.814 41.5445L27.8038 37.5157C29.3673 37.062 30.793 36.2956 32.0618 35.3341L23.8663 27.1798L23.8988 40.068L14.0956 30.314L6.27267 30.3337L6.2431 18.5994L14.066 18.5797L14.6317 17.9915L6.08324 9.48608ZM36.7592 28.9667C37.2641 27.5377 37.5535 25.9919 37.5495 24.3882C37.5339 18.1886 33.3941 12.9577 27.7378 11.29L27.7277 7.2612C35.5746 9.02115 41.4399 16.0079 41.4609 24.3784C41.4678 27.0968 40.8484 29.6604 39.759 31.9514L36.7592 28.9667ZM23.82 8.77725L20.1526 12.4633L23.8386 16.1308L23.82 8.77725ZM27.751 16.5301C30.6491 17.97 32.6514 20.9377 32.6601 24.3993C32.6605 24.5558 32.6413 24.7123 32.6222 24.8688L32.6222 24.8688L27.7598 20.0308L27.751 16.5301Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVolumeOff);
export default __webpack_public_path__ + "static/media/icon-volumeOff.d97732b35610818d25862fb34adb7b95.svg";
export { ForwardRef as ReactComponent };